import { Helmet } from "react-helmet-async";
import FoldersView from "../../organisms/Dashboard/FoldersView";

const FoldersPage = () => {
  return (
    <>
      <Helmet>
        <title>Folders</title>
      </Helmet>
      <FoldersView />
    </>
  );
};

export default FoldersPage;
